import {Drawer} from "antd";
import styled from "styled-components";

export const StyledStoreServiceOrderDrawer = styled(Drawer)`
  .ant-drawer-content-wrapper {
    width: 100% !important;
  }
  @media (min-width: 960px) {
    .ant-drawer-content-wrapper {
      width: 68.2rem !important;
    }
  }
`;
